var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgrssLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 2.41667H21.75V0H19.3333V2.41667H9.66667V0H7.25V2.41667H3.625C1.62642 2.41667 0 4.04308 0 6.04167V29H29V6.04167C29 4.04308 27.3736 2.41667 25.375 2.41667ZM26.5833 26.5833H2.41667V12.0833H26.5833V26.5833ZM26.5833 9.66667H2.41667V6.04167C2.41667 5.37587 2.958 4.83333 3.625 4.83333H25.375C26.042 4.83333 26.5833 5.37587 26.5833 6.04167V9.66667ZM10.9789 23.4586L7.61733 20.2009L9.30054 18.4645L12.6754 21.7355L19.6946 14.8468L21.3911 16.5687L14.3913 23.4646C13.9236 23.9323 13.3086 24.1655 12.6911 24.1655C12.0737 24.1655 11.4526 23.9298 10.9801 23.4586H10.9789Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgrssLogo);
export default __webpack_public_path__ + "static/media/in-progrss-logo.345923fd1aa3d1cd34013205f490f3c4.svg";
export { ForwardRef as ReactComponent };